import React from 'react';
import getConfig from 'next/config';
import dynamic from 'next/dynamic';
import { CollapsibleAccordionBox, UserInfoTitle } from '../../components';
import Footer from '../homepage/Footer/Footer';
import { USER_DATA_COLLECTION_CONSTANT, COOKIES_INFORMATION_CONSTANT, LANGUAGE_CONSTANT } from '../../shared/privacy_policy';
import './PrivacyContainer.sass';

const Meta = dynamic(() => import('../../components/Meta'));
const { APP_ENV } = getConfig().publicRuntimeConfig;

const PrivacyContainer = () => {
  return (
    <>
      <Meta
        title="Kebijakan Privasi – Lifepal"
        meta={[
          <meta
            key="description"
            name="description"
            content="Halaman ini menyediakan informasi mengenai kebijakan penggunaan data pelanggan Lifepal."
          />,
          <link
            key="canonical"
            rel="canonical"
            href={APP_ENV === 'production'
              ? 'https://lifepal.co.id/privasi/'
              : 'https://lifepal.tech/privasi/'
            }
          />,
          <meta property="og:title" content="Kebijakan Privasi – Lifepal" />,
          <meta
            property="og:description"
            content="Halaman ini menyediakan informasi mengenai kebijakan penggunaan data pelanggan Lifepal."
          />,
          <meta property="og:url" content="/privasi/" />,
          <meta name="twitter:card" content="Kebijakan Privasi - Lifepal" />
        ]}
      />
      
      <UserInfoTitle title="Kebijakan Privasi" />
      
      <div className="privacy--container">
        <div className="privacy__content--container">
          <p style={{fontSize: "16px"}}>
            PT Abisatya Pialang Asuransi (“Lifepal atau Kami”) menghargai kepercayaan   Anda. Kami berkomitmen untuk melindungi data pribadi setiap pengguna layanan kami sesuai dengan Undang-Undang dan Peraturan yang berlaku di Indonesia. Kebijakan Privasi ini menjelaskan informasi apa yang Kami kumpulkan bagaimana kami mengumpulkan, menggunakan, menyimpan, dan melindungi informasi Anda (&ldquo;<strong>Anda</strong>&rdquo;atau &ldquo;<strong>Milik Anda</strong>&rdquo;) ketika menggunakan Situs Web Lifepal.co.id (&ldquo;<strong>Situs Web</strong>&rdquo;) maupun layanan kami. Kebijakan Privasi bertujuan untuk memastikan bahwa Anda menyadari opsi yang tersedia bagi Anda ketika Anda mengakses dan menggunakan Layanan Kami sehingga dapat memenuhi kebutuhan Anda.
          </p>

          <p style={{fontSize: "16px"}}>
            Kebijakan Privasi ini dibuat dengan tujuan untuk menjaga dan memelihara privasi serta keamanan Data Pribadi Anda sesuai dengan prinsip pelindungan Data Pribadi dalam Undang-Undang No. 27 Tahun 2022 tentang Pelindungan Data Pribadi dan peraturan perundang-undangan yang relevan lainnya yang berlaku, termasuk perubahannya dari waktu ke waktu (&ldquo;<strong>Peraturan yang Berlaku</strong>&rdquo;).
          </p>

          <p style={{fontSize: "16px"}}>
            Dengan mengakses dan menggunakan Situs Web dan layanan yang kami berikan, Anda dianggap telah membaca, memahami, dan memberikan persetujuannya terhadap pengumpulan dan penggunaan Data Pribadi Pengguna sebagaimana dijelaskan dalam Kebijakan Privasi ini.
          </p>
        </div>
        
        <div className="privacy__content--container">
          <h3>Pengumpulan Data Pribadi</h3>

          {USER_DATA_COLLECTION_CONSTANT.map((policy, index) => (<CollapsibleAccordionBox policy={policy} key={`list-user-data-item-${index}`} />))}
        </div>

        <div className="privacy__content--container">
          <h3>Informasi Cookies </h3>

          {COOKIES_INFORMATION_CONSTANT.map((policy, index) => (<CollapsibleAccordionBox policy={policy} key={`list-cookies-information-item-${index}`} />))}
        </div>

        <div className="privacy__content--container">
          <h3>Bahasa</h3>
          
          {LANGUAGE_CONSTANT.map((policy, index) => (<CollapsibleAccordionBox policy={policy} key={`list-language-item-${index}`} />))}
        </div>

        <div className="privacy__content--container">
          <p>
            <strong>Diperbarui pada : Maret 2026</strong>
          </p>
        </div>
      </div>

      {/* when footer from design-system updated, remove this implementation */}
      <Footer />
    </>
  )
}

export default PrivacyContainer;